import { render, staticRenderFns } from "./MaterialReception.vue?vue&type=template&id=53780d36"
import script from "./MaterialReception.vue?vue&type=script&lang=js"
export * from "./MaterialReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports